import NextAuth from 'next-auth'
import { configuration as authConfig } from './nextauth-config'
import { reset } from './reset'
import { signup } from './signup'
import { verify } from './verify'

export { createAuthHandler }

/**
 * @param {{
 *   slugParam: string
 *   canSignIn: boolean
 *   canSignUp: boolean
 *   canReset: boolean
 * }} config
 */
function createAuthHandler({
  slugParam = 'synqly-auth',
  canReset = true,
  canSignUp = false,
  canSignIn = true,
}) {
  const Actions = {
    reset: canReset && reset,
    verify: canReset && verify,
    signup: canSignUp && signup,
    default: canSignIn && nextauth,
  }

  /** @type {import('next').NextApiHandler} */
  return async (req, res) => {
    const { [slugParam]: params } = req.query
    const [route] = params
    const authHandler = Actions[route] ?? Actions.default

    if (typeof authHandler !== 'function') {
      return res.status(404).send({ statusCode: 404, message: 'Not Found' })
    }

    req.query.nextauth = req.query[slugParam]
    return authHandler(req, res)
  }
}

/** @type {import('next').NextApiHandler} */
function nextauth(req, res) {
  const configuration = authConfig(req)
  return NextAuth.default(req, res, configuration)
}
